import { loadable } from "components/SpruceLoader";

export const JobLogs = loadable(() => import("./jobLogs/index"));
